import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorContrastService {


  private hexToRgb(hex: string): { r: number; g: number; b: number } {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }
    const bigint = parseInt(hex, 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255
    };
  }

  private getLuminance({ r, g, b }: { r: number; g: number; b: number }): number {
    const channel = (c: number) => {
      const sRGB = c / 255;
      return sRGB <= 0.03928 ? sRGB / 12.92 : Math.pow((sRGB + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
  }

  pickContrastColor(hex: string): string {
    try {
      if (!hex.startsWith('#')) return '#ffffff';
      const rgb = this.hexToRgb(hex);
      const luminance = this.getLuminance(rgb);
      return luminance > 0.5 ? '#000000' : '#ffffff';
    } catch {
      return hex;
    }
  }

  colorsAreSimilar(color1: string, color2: string): boolean {
    try {
      if (!color1 || !color2 || !color1.startsWith('#') || !color2.startsWith('#')) {
        return color1?.trim().toLowerCase() === color2?.trim().toLowerCase();
      }

      const rgb1 = this.hexToRgb(color1);
      const rgb2 = this.hexToRgb(color2);

      const distance = Math.sqrt(
        Math.pow(rgb1.r - rgb2.r, 2) +
        Math.pow(rgb1.g - rgb2.g, 2) +
        Math.pow(rgb1.b - rgb2.b, 2)
      );

      const threshold = 70; 
      return distance < threshold;
    } catch (err) {
      console.error('Error comparing colors:', err);
      return color1?.trim().toLowerCase() === color2?.trim().toLowerCase();
    }
  }

}
